import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from '../base';
import { CreateObject } from '../item';
import { Product } from './product';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { ProductType } from '../types';
import { PriceZoneType } from '../types';
import { PriceTimeType } from '../types';

const _schema = {
    name: 'PRODUCTPRICE',
    fields: [
        { name: 'status', type: 'string', default: 'AC' },
        { name: 'product', type: 'objid' },
        { name: 'pricezone', type: 'objid' },
        { name: 'pricetime', type: 'objid' },
        { name: 'price', type: 'number' },
    ],
    relate: [
        { direction: '>', target: 'PRODUCT', by: 'product', name: 'product', reason: 'product', child: false, class: ProductType },
        { direction: '>', target: 'PRICEZONE', by: 'pricezone', name: 'pricezone', reason: 'pricezone', child: false, class: PriceZoneType },
        { direction: '>', target: 'PRICETIME', by: 'pricetime', name: 'pricetime', reason: 'pricetime', child: false, class: PriceTimeType },
    ]
} as const;

const _ProductPriceClass = CreateObject(_schema);
if (!_ProductPriceClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class ProductPrice extends _ProductPriceClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): ProductPrice {
        return this._Copy(store) as ProductPrice;
    }

    /** Changelog rows lack parent 1:N lists; register on link (see Preselect / TicketProduct). */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'product' && related instanceof Product){
            if (related === this.product){
                related.AddPrice(this);
            }
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/

    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.product){
            if ((this.status == 'DE') && !this.Commited){
                this.product.DelPrice(this);
            }
            else {
                this.product.DoRefresh(this.table);
            }
        }
    }

    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}
